<template>
  <div
    class="td"
    :class="[ name, { 'sorter-wrap' : sort } ]"
    ref="td"
    @click="triggerSort(name)"
  >

    <div
      class="td-text"
      :style="`width: ${this.span_w}px`"
      v-if="!isHtml"
    >
      <slot></slot>
    </div>

    <div
      class="td-text"
      v-html="logs"
      :style="`width: ${this.span_w}px`"
      v-else
    >
    </div>

    <span
      class="sort"
      ref="sort"
      v-if="sort"
    >
      <i
        class="ico--sort-asc"
        :class="{ '-active' : tblConfig.td_name === name && tblConfig.asc }"
      >
      </i>
      <i
        class="ico--sort-desc"
        :class="{ '-active' : tblConfig.td_name === name && !tblConfig.asc }"
      >
      </i>
    </span>
  </div>
</template>

<script>
//= mixins
import { ready } from '@/assets/js/mixins/base/Ready'
import { getStyles } from '@/assets/js/mixins/base/GetStyles'

export default {
  name: 'tbl-td',

  props: {
    sort: {
      type: Boolean,
      default: false
    },

    name: {
      type: [ String ]
    },

    isHtml: {
      type: Boolean,
      default: false
    },

    logs: {
      type: [ String ]
    }
  },

  inject: {
    tblConfig: {}
  },

  mixins: [ ready, getStyles ],

  data () {
    return {
      sort_w: null,
      td_w: null,
      span_w: null
    }
  },

  mounted () {
    let padding = this.getComputedStyles('paddingLeft', this.$refs.td) + this.getComputedStyles('paddingRight', this.$refs.td)

    this.$loaded(() => {
      if (this.$refs.td) {
        this.td_w = this.$refs.td.offsetWidth

        if (this.$refs.sort) {
          this.sort_w = this.$refs.sort.offsetWidth
        }

        if (this.td_w && this.sort_w) {
          this.span_w = this.td_w - this.sort_w - padding - 2
        }
      }
    }, 1000)
  },

  methods: {
    triggerSort (name) {
      if (this.sort) {
        this.tblConfig.td_name = name

        if (this.tblConfig.td_name === name) {
          this.tblConfig.asc = !this.tblConfig.asc
        }
      }
    }
  }
}
</script>
